import { useAuthStore } from "@/state/pinia";

export default async (to, from, next) => {
    const authStore = useAuthStore();

    //for Server Side Validate.
    if(process.env.VUE_APP_API_VALIDATE_TOKEN == 'serverSide')
    {
        const status = await authStore.validate();
        
        if(status == 200)
        {
            return next({ name: 'default' })
        }

        return next()
    }
    //for Client Side Validate.
    else if(authStore.loggedIn){
        return next({ name: 'default' })
    }

    next()
}